<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  components: { Layout, VclList },
  data() {
    return {
      loading: true,
      errored: false,

      // Dados
      items: null,
      totalLeads: 0,

      // Tabela
      fields: [
        { key: "lead_date", label: "Data / Hora", sortable: false },
        { key: "lead_date_raw", label: "", sortable: true, thClass: 'd-none', tdClass: 'd-none' },
        { key: "lead_nome", label: "Nome", sortable: true },
        { key: "lead_email", label: "Email", sortable: false },
        { key: "lead_telefone", label: "Telefone", sortable: false },
        { key: "_actions", label: "", class: "text-right" },
      ],
      sortBy: "lead_date_raw",
      sortDesc: true,
      currentPage: 1,
      perPage: "25",

      // Filtro
      NameFilter: "",

      // Ícone WhatsApp (SVG inline)
      whatsappIcon:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="24" height="24"><path d="M188.1 318.6C188.1 343.5 195.1 367.8 208.3 388.7L211.4 393.7L198.1 442.3L248 429.2L252.8 432.1C273 444.1 296.2 450.5 319.9 450.5L320 450.5C392.6 450.5 453.3 391.4 453.3 318.7C453.3 283.5 438.1 250.4 413.2 225.5C388.2 200.5 355.2 186.8 320 186.8C247.3 186.8 188.2 245.9 188.1 318.6zM370.8 394C358.2 395.9 348.4 394.9 323.3 384.1C286.5 368.2 261.5 332.6 256.4 325.4C256 324.8 255.7 324.5 255.6 324.3C253.6 321.7 239.4 302.8 239.4 283.3C239.4 264.9 248.4 255.4 252.6 251C252.9 250.7 253.1 250.5 253.3 250.2C256.9 246.2 261.2 245.2 263.9 245.2C266.5 245.2 269.2 245.2 271.5 245.3L272.3 245.3C274.6 245.3 277.5 245.3 280.4 252.1C281.6 255 283.4 259.4 285.3 263.9C288.6 271.9 292 280.2 292.6 281.5C293.6 283.5 294.3 285.8 292.9 288.4C289.5 295.2 286 298.8 283.6 301.4C280.5 304.6 279.1 306.1 281.3 310C296.6 336.3 311.9 345.4 335.2 357.1C339.2 359.1 341.5 358.8 343.8 356.1C346.1 353.5 353.7 344.5 356.3 340.6C358.9 336.6 361.6 337.3 365.2 338.6C368.8 339.9 388.3 349.5 392.3 351.5C393.1 351.9 393.8 352.2 394.4 352.5C397.2 353.9 399.1 354.8 399.9 356.1C400.8 358 400.8 366 397.5 375.2C394.2 384.5 378.4 392.9 370.8 394zM544 160C544 124.7 515.3 96 480 96L160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160zM244.1 457.9L160 480L182.5 397.8C168.6 373.8 161.3 346.5 161.3 318.5C161.4 231.1 232.5 160 319.9 160C362.3 160 402.1 176.5 432.1 206.5C462 236.5 480 276.3 480 318.7C480 406.1 407.3 477.2 319.9 477.2C293.3 477.2 267.2 470.5 244.1 457.9z"/></svg>',
    };
  },
  methods: {
    getList() {
      this.loading = true;
      this.errored = false;
      this.items = null;
      this.totalLeads = 0;
      this.currentPage = 1;

      api
        .get("lead/list?searchname=" + encodeURIComponent(this.NameFilter || ""))
        .then((response) => {
          if (response.data.status === "success") {
            // Ordena localmente por data/hora real
            this.items = response.data.list.sort(
              (a, b) => new Date(b.lead_date_raw) - new Date(a.lead_date_raw)
            );
            this.totalLeads = parseInt(response.data.total || 0);
          } else {
            this.items = [];
            this.totalLeads = 0;
          }
        })
        .catch((error) => {
          this.errored = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendWhatsApp(lead) {
      const message =
        "Olá,\n" +
        "Boa notícia! Há um Novo Lead para você\n" +
        `Nome: ${lead.lead_nome}\n` +
        `Email: ${lead.lead_email}\n` +
        `Telefone: ${lead.lead_telefone}\n` +
        `Estado: ${lead.lead_estado}\n` +
        `Origem: ${lead.lead_origem}\n` +
        `Mídia: ${lead.lead_midia}\n\n` +
        `*Informações do Veículo:*\n` +
        `Marca: ${lead.lead_marca}\n` +
        `Modelo: ${lead.lead_modelo}\n` +
        `Placa: ${lead.lead_placa}\n\n` +
        `*Mensagem do Lead:*\n` +
        `${lead.lead_mensagem || ""}`;

      const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    },
    goToLead(id) {
      // Use router se existir rota SPA, ou troque para window.location.href se preferir navegação tradicional.
      this.$router
        ? this.$router.push(`/lead/${id}`).catch(() => {})
        : (window.location.href = `/lead/${id}`);
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    NameFilter() {
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Título -->
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Leads</h3>
        <p></p>
      </div>
    </div>

    <!-- Totais e Itens por página -->
    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">total de leads</h6>
        <div>{{ totalLeads | points }}</div>
      </div>

      <!-- Removido "Tipo" conforme pedido -->

      <b-dropdown variant="outline-light" class="ml-2">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">itens por página</h6>
              <div>{{ perPage }} itens</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
    </div>

    <!-- Filtro por nome -->
    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">Filtrar por nome</h6>
      </div>
      <input
        v-model="NameFilter"
        type="text"
        class="form-control search"
        id="nameFilter"
        aria-label="Nome do Lead"
        placeholder="Nome do Lead"
      />
    </div>

    <!-- Tabela -->
    <div class="card">
      <div class="card-body min-vh-25">
        <div class="error text-center min-vh-25" v-if="errored">
          Pedimos desculpas, não podemos recuperar informações neste momento. Por favor, tente novamente mais tarde.
        </div>
        <vcl-list v-else-if="loading" class="col-md-6"></vcl-list>

        <div
          v-else-if="items && items.length === 0"
          class="empty text-center min-vh-25 d-flex align-items-center justify-content-center"
        >
          <strong>Nenhum registro encontrado.</strong>
        </div>

        <div v-else class="table-responsive">
          <b-table stacked="md"
            :items="items"
            :fields="fields"
            class="table-nowrap table-style table-hover min-vh-25"
            head-variant="light"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :per-page="perPage"
            responsive
          >
            <!-- Coluna de Ações -->
            <template #cell(_actions)="row">
              <div class="text-right">
                <button class="btn btn-primary btn-xs mr-2" @click="goToLead(row.item.lead_uuid)">
                  Ver
                </button>
                <button
                  class="btn btn-outline-success btn-xs"
                  @click="sendWhatsApp(row.item)"
                  v-html="whatsappIcon"
                  title="Enviar pelo WhatsApp"
                ></button>
              </div>
            </template>
          </b-table>

          <b-pagination
            v-if="totalLeads > 0"
            class="m-0 mt-3"
            v-model="currentPage"
            :total-rows="totalLeads"
            :per-page="perPage"
            pills
            align="center"
          ></b-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>
